export function generateVisitorId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes).map(b => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

const UUID_V4 = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isValidVisitorId(value: unknown): value is string {
  return typeof value === 'string' && UUID_V4.test(value);
}

/**
 * Normaliza um visitorId guardado no localStorage. Widgets antigos gravavam `vis_<uuid>`, formato
 * que a API não aceita: removemos o prefixo (preserva a identidade do visitante). Retorna null
 * se o valor não for um UUID v4 utilizável.
 */
export function normalizeVisitorId(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const bare = value.startsWith('vis_') ? value.slice(4) : value;
  return isValidVisitorId(bare) ? bare : null;
}
